var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiFormStep',{staticClass:"submit-step",attrs:{"prev":true,"next":false,"submit":true,"invalid":_vm.isInvalid || !_vm.captchaValid},on:{"form:prev":function($event){return _vm.onPrev()}}},[_c('UiFormField',{attrs:{"id":"contact-mentor-firstname","label":_vm.$translation('form.label.firstname'),"type":"input","control":{
      name: 'firstname',
      placeholder: _vm.$translation('form.placeholder.firstname'),
      value: _vm.formData.firstname,
      required: true,
      autocomplete: 'given-name',
    }},on:{"input":function($event){return _vm.onInput('firstname', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),_c('UiFormField',{attrs:{"id":"contact-mentor-lastname","label":_vm.$translation('form.label.lastname'),"type":"input","control":{
      name: 'lastname',
      placeholder: _vm.$translation('form.placeholder.lastname'),
      value: _vm.formData.lastname,
      required: true,
      autocomplete: 'family-name',
    }},on:{"input":function($event){return _vm.onInput('lastname', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),_c('UiFormField',{attrs:{"id":"contact-mentor-email","label":_vm.$translation('form.label.email'),"type":"input","control":{
      name: 'email',
      placeholder: _vm.$translation('form.placeholder.email'),
      value: _vm.formData.email,
      type: 'email',
      required: true,
      autocomplete: 'email',
    }},on:{"input":function($event){return _vm.onInput('email', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),(_vm.$i18n.locale === 'en_gb')?_c('UiFormField',{attrs:{"id":"contact-mentor-phone","label":_vm.formattedAnswer(1),"type":"input","control":{
      name: 'phone',
      placeholder: _vm.formattedAnswer(2),
      type: 'tel',
      autocomplete: 'tel',
      value: _vm.formData.phone,
      required: false,
    }},on:{"input":function($event){return _vm.onInput('phone', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}):_vm._e(),_vm._v(" "),_c('UiFormField',{attrs:{"id":"contact-mentor-audiology","label":_vm.formattedAnswer(3),"type":"input","control":{
      name: 'clinic',
      placeholder: '',
      type: 'text',
      autocomplete: 'text',
      value: _vm.formData.clinic,
      required: false, // Set to true if it's required
    }},on:{"input":function($event){return _vm.onInput('clinic', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),_c('UiFormField',{attrs:{"id":"contact-mentor-country","label":_vm.$translation('form.label.country'),"type":"select-country","control":{
      name: 'country',
      placeholder: _vm.$translation('form.placeholder.country'),
      autocomplete: 'country',
      value: _vm.formData.country,
      required: true,
      noGroupOptions: true,
    }},on:{"input":function($event){return _vm.onInput('country', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),_c('UiFormField',{attrs:{"id":"contact-mentor-privacy","type":"checkbox","control":{
      name: 'privacy',
      value: _vm.formData.privacy,
      label: _vm.$translation('form.label.privacy'),
      required: true,
    }},on:{"input":function($event){return _vm.onInput('privacy', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),_c('UiFormField',{attrs:{"id":"contact-mentor-newsletter","type":"checkbox","control":{
      name: 'newsletter',
      value: _vm.formData.newsletter,
      label: _vm.formattedAnswer(0),
    }},on:{"input":function($event){return _vm.onInput('newsletter', $event)},"invalid":function($event){return _vm.onInvalid($event)}}}),_vm._v(" "),_c('div',{staticClass:"form-captcha"},[_c('vue-hcaptcha',{attrs:{"sitekey":_vm.captchaSiteKey,"language":_vm.captchaLanguage},on:{"verify":_vm.onCaptchaVerify,"error":_vm.onCaptchaError,"expired":_vm.onCaptchaExpired}})],1),_vm._v(" "),_c('small',{domProps:{"innerHTML":_vm._s(_vm.privacyHint)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }